module.exports = __webpack_public_path__ + "static/media/header-sebaran-jawaban-agcu-merah.db89f770.png";